// Core packages
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { IUser } from "src/app/shared/models/user/user.interface";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { CondoStructuresService } from "../../condo-structures.service";

/**
 * Script start
 */

@Component({
  selector: "app-property-detail-mapping-item-dialog",
  templateUrl: "./mapping-item-dialog.component.html",
  styleUrls: ["./mapping-item-dialog.component.scss"]
})
export class PropertyDetailMappingItemDialogComponent
  implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  dialogIsLoading = false; // Used to view/hide form loading spinner

  // BEGIN - Edit item form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true
    }
  };
  // END - Edit item form
  existingNotes: any[] = [];
  qrcodeData = "";

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PropertyDetailMappingItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configService: ConfigService,
    private propertiesService: PropertiesService,
    private translateService: TranslateService,
    private authService: AuthService,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private toastrService: ToastrService,
    private helperService: HelperService,
    private condoStructuresService: CondoStructuresService
  ) {}

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    if (this.data.item) {
      this.qrcodeData = JSON.stringify({
        item: this.data.item._id,
        section: this.data.itemConfig.section
      });
    }

    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe(res => (this.loggedUser = res))
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        res => (this.loggedUserPermissions = res)
      )
    );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    // Init form
    this.initForm();
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    if (this.data) {
      if (this.data.item) {
        this.model = this.data.item;

        if (this.data.item.note) {
          this.existingNotes = this.data.item.note;
          this.data.item.note = null;
        }
      }

      if (this.data.itemConfig && this.data.itemConfig.formConfig) {
        this.fields = [this.data.itemConfig.formConfig];
      }
    } else {
      // this.toastrService.error('Errore nel recupero dei dati');
      // this.onClose(null);
    }
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(data?: any): void {
    this.data.item.note = this.existingNotes;
    this.dialogRef.close();
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(model: any): void {
    // Prevent invalid form submit
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        this.form.controls[key].markAsTouched();
      });
      console.warn("form", this.form);
      this.toastrService.error(
        this.translateService.instant("common.errors.form_is_invalid")
      );
      return;
    }

    // We want to send only the ID of selected company
    // if (model.admin && model.admin.company) {
    //   model.admin.company = model.admin.company._id;
    // }

    // We want to send only the ID of selected owner
    // if (model.owner) {
    //   model.owner = model.owner._id;
    // }

    // Activate submit button loading status
    this.formBtnOptions.active = true;

    // If data.item is set means we are updating an exising item
    // Otherwise it's a item creation!
    if (this.data.item) {
      // this.subscriptions.push(
      //   this.condoStructuresService
      //     .updateSection(
      //       this.data.itemConfig.section,
      //       this.data.property.structure,
      //       this.data.item._id,
      //       model
      //     )
      //     .pipe(finalize(() => (this.formBtnOptions.active = false)))
      //     .subscribe(
      //       res => {
      //         if (res.status) {
      //           this.toastrService.success(res.message);
      //           if (model.note) {
      //             const newNoteData = {
      //               text: model.note,
      //               createdAt: new Date(),
      //               createdBy: this.loggedUser._id
      //             };
      //             this.existingNotes.push(newNoteData);
      //           }
      //         }
      //       },
      //       err => {
      //         // Choose one of the following error handling method.
      //         // 1) First one show a message right under the form fields
      //         //    (if the form is properly setted)
      //         // 2) Second one is used to show a mat-error under each field
      //         //    in the dynamic form (is meant to be used only in dynamicForm)
      //         // 3) Third one show toastr notifications for each error
      //         // 4) Fourth one is used to show mat-error under each field
      //         //    in the ngx-formly form (is mean to be used only with ngx-formly)
      //         // this.helperService.handleFormError(form, err);
      //         // this.helperService.handleDynamicFormError(form, err);
      //         // this.helperService.handleError(err);
      //         this.helperService.handleFormlyError(this.form, err);
      //       }
      //     )
      // );
    } else {
      this.subscriptions.push(
        this.condoStructuresService
          .createSectionItem(
            this.data.itemConfig.section,
            this.data.property.structure,
            this.form.value
          )
          .pipe(finalize(() => (this.formBtnOptions.active = false)))
          .subscribe(
            res => {
              if (res.status) {
                this.toastrService.success(res.message);
                this.dialogRef.close({
                  newFormItem: res.item
                });
              }
            },
            err => {
              // Choose one of the following error handling method.
              // 1) First one show a message right under the form fields
              //    (if the form is properly setted)
              // 2) Second one is used to show a mat-error under each field
              //    in the dynamic form (is meant to be used only in dynamicForm)
              // 3) Third one show toastr notifications for each error
              // 4) Fourth one is used to show mat-error under each field
              //    in the ngx-formly form (is mean to be used only with ngx-formly)
              // this.helperService.handleFormError(form, err);
              // this.helperService.handleDynamicFormError(form, err);
              // this.helperService.handleError(err);
              this.helperService.handleFormlyError(this.form, err);
            }
          )
      );
    }
  }
}
